module.exports = __webpack_public_path__ + "img/kuangjiao_yj_bingshichuan.aa08b7b0.jpg";